import { Text, TextProps } from '@wegroup/design-system';
import React from 'react';

const RedAsterix: React.FC<TextProps> = (props) => {
  return (
    <Text as="span" color="danger.main" {...props}>
      *
    </Text>
  );
};

export default RedAsterix;
